import { render, staticRenderFns } from "./dialog-attachment-confirmation.vue?vue&type=template&id=6f5dd5d2&scoped=true&"
import script from "./dialog-attachment-confirmation.vue?vue&type=script&lang=js&"
export * from "./dialog-attachment-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5dd5d2",
  null
  
)

export default component.exports